.aj{justify-content:center;}